import { render, staticRenderFns } from "./PayslipsTab.vue?vue&type=template&id=6d647cbe"
import script from "./PayslipsTab.vue?vue&type=script&lang=js"
export * from "./PayslipsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports